import { __assign } from "tslib";
import { styled, Badge as MuiBadge } from '@mui/material';
export var StyledBadge = styled(MuiBadge, {
    shouldForwardProp: function (prop) { return !['position'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, position = _a.position;
    return (__assign({}, (position === false && {
        position: "static",
        '.MuiBadge-badge': {
            position: "static",
            transform: "none"
        }
    })));
});
//# sourceMappingURL=styled.js.map